import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/content';
import { BONUS_SIZES, BONUS_WIDTHS, optimizedImage, optimizedSrcSet } from '../utils/images';
import { Accent, SectionHeading } from './SectionHeading';
export function BonusesSection() {
  return <section className="w-full bg-cream-100 px-6 pb-10 pt-2 sm:pb-12" aria-labelledby="bonuses-title" data-id="element-16" data-mp="qu2xedxwt2fj">
      <div className="mx-auto max-w-4xl" data-id="element-17" data-mp="14tb1nl8xj0ql">
        <SectionHeading id="bonuses-title" badge="Included at no extra cost" badgeIcon={GiftIcon} title={<>
              5 Bonuses <Accent data-id="element-19" data-mp="1ejnib2dmi9rg">Included</Accent>
            </>} subtitle="Each bonus solves a specific implementation need." data-id="element-18" data-mp="14s9l51959m1h" />

        <ul className="mt-6 grid gap-3.5 sm:grid-cols-2" data-id="element-20" data-mp="19mdwdwpg0g8d">
          {bonuses.map(({
          number,
          title,
          description,
          image
        }) => <li key={number} className="flex h-full flex-col overflow-hidden rounded-2xl border border-cream-300/70 bg-cream-50 p-4" data-id="element-21" data-mp="1jiqnqnximhzy">
              <div className="relative overflow-hidden rounded-xl" data-id="element-22" data-mp="3psen26ssnab4">
                <img src={optimizedImage(image, 420)} srcSet={optimizedSrcSet(image, BONUS_WIDTHS)} sizes={BONUS_SIZES} alt={`Cover of bonus ${number}: ${title}`} width={1200} height={900} loading="lazy" decoding="async" className="aspect-[4/3] w-full object-cover" data-id="element-23" data-mp="3tsoy3xvg0qwu" />
                <span className="absolute left-3 top-3 rounded-md bg-ember-500 px-2.5 py-1 text-[0.65rem] font-bold uppercase tracking-wider text-white" data-id="element-24" data-mp="lc3smr20sfyh">
                  Bonus {number}
                </span>
                <span className="absolute right-3 top-3 rounded-md bg-forest-800 px-2.5 py-1 text-[0.65rem] font-bold uppercase tracking-wider text-ember-400" data-id="element-25" data-mp="vajmv2wcg5c7">
                  Free
                </span>
              </div>
              <h3 className="mt-4 font-display text-lg font-bold uppercase leading-snug text-forest-800" data-id="element-26" data-mp="amac46uq8kf1">
                {title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-forest-700/85" data-id="element-27" data-mp="5kb5mo3ox7dv">{description}</p>
            </li>)}

          <li className="flex h-full flex-col items-center justify-center rounded-2xl bg-forest-800 p-8 text-center" data-id="element-28" data-mp="fklked5dimv5">
            <p className="font-display text-2xl font-bold uppercase leading-snug text-cream-50" data-id="element-29" data-mp="taxe2ghlwtoe">
              All 5 bonuses <span className="text-ember-400" data-id="element-30" data-mp="obly39p2ds7v">included free</span>
            </p>
            <p className="mt-3 text-sm text-cream-100/75" data-id="element-31" data-mp="13a64izd9jq60">
              Everything you need to launch the system in your program.
            </p>
          </li>
        </ul>
      </div>
    </section>;
}